const API_VERSION = 'v2'

/**
 * @return string
 */
const getBaseSiteUrl = function () {
  return `${location.protocol}//${window.location.hostname}`
}

/**
 * @return string
 */
const getBaseApiUrl = function () {
  // Same-origin API mode (Railway/PR deploys): the web server routes
  // /v1|/v2 to PHP on the same host, so there is no rest.* subdomain.
  if (process.env.VUE_APP_API_SAME_ORIGIN === 'true') {
    return `${location.protocol}//${window.location.host}/${API_VERSION}`
  }
  const url = window.location.hostname.split('.')
  url[0] = 'rest'
  return `${location.protocol}//${url.join('.')}/${API_VERSION}`
}

/**
 * @return string
 */
const getBaseSocketUrl = function () {
  // Deploys without the socket.* subdomain scheme (Railway/PR deploys)
  // point directly at the socket service's own domain.
  if (process.env.VUE_APP_SOCKET_BASE_URL) {
    return process.env.VUE_APP_SOCKET_BASE_URL
  }
  const url = window.location.hostname.split('.')
  url[0] = 'socket'
  return `${location.protocol}//${url.join('.')}`
}

/**
 * @return string
 */
const getBaseApiDocsUrl = function () {
  const url = window.location.hostname.split('.')
  url[0] = 'docs'
  return `${location.protocol}//${url.join('.')}`
}

/**
 * Get the root domain for cookies (e.g., '.verofresh.com')
 * This allows all subdomains (e.g., chatbot.verofresh.com, app.staging.verofresh.com)
 * to share cookies with each other.
 * @return string|undefined - Returns undefined for localhost/local dev (uses default cookie behavior)
 */
const getCookieDomain = function () {
  const hostname = window.location.hostname

  // Don't set domain for localhost or IP addresses - use default cookie behavior
  if (hostname === 'localhost' || hostname.match(/^(\d{1,3}\.){3}\d{1,3}$/)) {
    return undefined
  }

  // In same-origin API mode there are no sibling subdomains to share cookies
  // with, and the parent domain may be a public suffix (e.g. railway.app)
  // where browsers silently reject domain cookies — use host-only cookies.
  if (process.env.VUE_APP_API_SAME_ORIGIN === 'true') {
    return undefined
  }

  const parts = hostname.split('.')

  // Need at least 2 parts for a valid domain (e.g., verofresh.com)
  if (parts.length < 2) {
    return undefined
  }

  // Always return the top-level domain (last 2 parts)
  // app.verofresh.com -> .verofresh.com
  // app.staging.verofresh.com -> .verofresh.com
  // chatbot.verofresh.com -> .verofresh.com
  return '.' + parts.slice(-2).join('.')
}

export default {
  getCookieDomain,
  getSiteUrl (path) {
    return getBaseSiteUrl() + '/' + path
  },
  getApiUrl (path) {
    let url = getBaseApiUrl()
    if (path !== undefined) {
      url = url + '/' + path
    }
    return url
  },
  getSocketUrl (path) {
    let url = getBaseSocketUrl()
    if (path !== undefined) {
      url = url + '/' + path
    }
    return url
  },
  getPath: function () {
    return window.location.pathname
  },
  getBaseApiDocsUrl: function () {
    return getBaseApiDocsUrl()
  }
}
